import React from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { Grid, Box } from '@material-ui/core'
import Paper from '@material-ui/core/Paper'
import FormLabel from '@material-ui/core/FormLabel'
import LiquidSelectAdapter from '@src/components/LiquidSelectAdapter'
import { Formik, Field } from 'formik'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import { modificationTypeValueWithProperties } from '@src/routes/Configurators/components/OptionalModifications/ModificationResponse'
import LiquidInputAdapter from '@src/components/LiquidInputAdapter'
import clsx from 'clsx'
import DeleteAllDialog from '@src/routes/Configurators/components/DeleteDialog'
import { configContext } from '../DnaPlates'
import {
  useRuleValidatePlateMutation,
  usePlateSessionFieldMutation,
} from '@src/mutations/ConfiguratorTubesMutation.generated'
import ValidationErrors from '../../../validations/ValidationErrors'
import messages from '../../../messages'
import { FormattedMessage, useIntl } from 'react-intl'
import { EmptyResponse, emptyWellList, EmptyState } from '../Reducer'
import {
  modificationNone,
  WarningKey,
  ActiveLinkTypeDnaplate,
  PlateProduct,
  CountryCodes,
} from '../enum'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import {
  validateTextUpdated as validateText,
  convertToASCII,
} from '@src/routes/Configurators/utils/util'
import IconButton from '@material-ui/core/IconButton'
import ClearIcon from '@material-ui/icons/Clear'
import { ConfiguratorValues } from '@src/routes/Configurators/utils/constants'
import {
  formatSequence,
  sequenceCount,
} from '@src/routes/Configurators/utils/formatSequence'
import useDebounce from '@src/routes/Configurators/utils/ConfiguratorDebounce'
import { TubeProperties } from '../../../utils/enum'
import CircleLoader from '@src/components/CircleLoader'
import ValidationWarnings from '@src/routes/Configurators/validations/ValidationWarnings'
import styles from '@src/routes/Configurators/utils/styles'
import { useRouter, dnaPlatesRoute } from '@src/routes'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
  },
  rootQa: {
    '& > *': {
      margin: theme.spacing(0),
    },
  },
  headerPad: {
    paddingLeft: theme.spacing(6),
  },
  conainerSpacing: {
    paddingLeft: theme.spacing(8.5),
    paddingBottom: theme.spacing(6),
    paddingTop: theme.spacing(6),
  },
  seqPad: {
    paddingTop: theme.spacing(8),
  },
  oligoPad: {
    paddingTop: theme.spacing(8),
    marginLeft: theme.spacing(12),
  },
  oligoPadLeft: {
    paddingLeft: theme.spacing(12),
  },
  TextFontRes: {
    padding: theme.spacing(3.5),
    fontWeight: theme.typography.fontWeightMedium,
  },
  textAlign: {
    fontWeight: theme.typography.fontWeightMedium,
    padding: theme.spacing(3, 0, 2, 3),
  },
  textWidth: {
    width: theme.spacing(72),
  },
  textWidthSequence: {
    width: theme.spacing(72),
    padding: theme.spacing(1, 0, 0.5, 0),
  },
  AddModificationButton: {
    marginTop: theme.spacing(5),
    width: theme.spacing(50),
  },
  leftMargin: {
    marginLeft: theme.spacing(-6),
  },
  oligoMargin: {
    marginTop: theme.spacing(4),
    paddingTop: theme.spacing(2),
  },
  divider: {
    width: 1,
    height: 192,
    margin: theme.spacing(15),
  },
  preview: {
    overflowWrap: 'break-word',
    fontWeight: theme.typography.fontWeightMedium,
  },
  wordWrap: {
    wordWrap: 'break-word',
  },
  oligoName: {
    margin: theme.spacing(0, 0, 0, 3),
  },
  sideHeadingMargin: {
    marginTop: theme.spacing(2),
  },
  propertiesPadding: {
    padding: theme.spacing(3.5, 0, 3.5, 0),
    fontWeight: theme.typography.fontWeightMedium,
  },
  subheadColor: {
    color: '#1b1b25',
  },
  over1: {
    fontSize: theme.typography.pxToRem(14),
    color: '#1d5293',
    fontWeight: theme.typography.fontWeightMedium,
    paddingLeft: theme.spacing(2),
  },
  overrideCheckBox: {
    padding: theme.spacing(0),
  },
  modificationsWidth: {
    width: theme.spacing(35),
  },
  overrideMargin: {
    textAlign: 'right',
    paddingTop: theme.spacing(1),
  },
  marginRoot: {
    marginRight: theme.spacing(0),
  },
  warningText: {
    marginLeft: theme.spacing(7),
  },
  alignRight: {
    textAlign: 'right',
  },
  clearButton: {
    float: 'right',
    padding: theme.spacing(1),
  },
  closeIcon: {
    padding: theme.spacing(0, 4, 0, 0),
  },
  disableMod: {
    color: '#757575',
  },
  emptyPreview: {
    overflowWrap: 'break-word',
    fontSize: theme.typography.pxToRem(14),
  },
  marginProperties: {
    marginLeft: theme.spacing(3),
  },
  nameHelpText: {
    fontSize: theme.typography.pxToRem(10.8),
  },
  fieldLabel: {
    '& label': {
      fontWeight: 'bold',
      minHeight: 12,
    },
  },
}))

export interface MixedProps {
  specificationsData: any
  well: any
  row: string
  col: string
  productDetails: any
  updatedData: any
}
const INITIAL_VALUES = {
  FiveModificationSelect: 'ALL',
  ThreeModificationSelect: 'ALL',
  oligoName: '',
}

export enum DefaultValue {
  Select = 'select',
  ThreeModification = 'threeMod',
  FiveModiFication = 'fiveMod',
  Category = '',
}

const idGeneration = [
  { key: 'A', value: 0 },
  { key: 'B', value: 13 },
  { key: 'C', value: 25 },
  { key: 'D', value: 37 },
  { key: 'E', value: 49 },
  { key: 'F', value: 61 },
  { key: 'G', value: 73 },
  { key: 'H', value: 85 },
  { key: 'I', value: 97 },
  { key: 'J', value: 109 },
  { key: 'K', value: 121 },
  { key: 'L', value: 133 },
  { key: 'M', value: 145 },
  { key: 'N', value: 157 },
  { key: 'O', value: 169 },
  { key: 'P', value: 181 },
]
let insertPos = 0
let insertPosReverse = 0
const OligoSequenceMixedWell: React.FC<MixedProps> = (props) => {
  const intl = useIntl()
  const { specificationsData, well, row, col, productDetails, updatedData } =
    props
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const classes = useStyles()
  const GlobalCSS = styles()
  const router = useRouter()
  const [callDebounceCall, setCallDebounceCall] = React.useState(false)
  const [callDebounceReverseCall, setCallDebounceReverseCall] =
    React.useState(false)
  const [callNameDebounce, setCallNameDebounce] = React.useState(false)
  const [callDebounceNameReverse, setCallDebounceNameReverse] =
    React.useState(false)
  const [sequenceForward, setSequenceForward] = React.useState('')
  const [baseCountForward, setBaseCountForward] = React.useState(0)
  const [oligoNameForward, setOligoNameForward] = React.useState('')
  const [threeModeValueTypeForward, setThreeModeValueTypeForward] =
    React.useState('')
  const [fiveModeValueTypeForward, setFiveModeValueTypeForward] =
    React.useState('')
  const [sequenceReverse, setSequenceReverse] = React.useState('')
  const [baseCountReverse, setBaseCountReverse] = React.useState(0)
  const [oligoNameReverse, setOligoNameReverse] = React.useState('')
  const [threeModeValueTypeReverse, setThreeModeValueTypeReverse] =
    React.useState('')
  const [fiveModeValueTypeReverse, setFiveModeValueTypeReverse] =
    React.useState('')
  const { state, dispatch } = React.useContext(configContext)
  const { sessionData, currentPlateIndex, productInformation } = state
  const { instructions } = productInformation
  const [isOverridenForward, setIsOverridenForward] = React.useState(false)
  const [isOverridenReverse, setIsOverridenReverse] = React.useState(false)
  const [idForward, setIdForward] = React.useState(0)
  const [idReverse, setIdReverse] = React.useState(0)
  const debouncedSequenceData = useDebounce(
    sequenceForward,
    TubeProperties.SEQUENCE_API_TIME
  )
  const debouncedSequenceReverseData = useDebounce(
    sequenceReverse,
    TubeProperties.SEQUENCE_API_TIME
  )
  const debouncedNameForwardData = useDebounce(
    oligoNameForward,
    TubeProperties.SEQUENCE_API_TIME
  )
  const debouncedNameReverseData = useDebounce(
    oligoNameReverse,
    TubeProperties.SEQUENCE_API_TIME
  )
  const [callRuleValidation, setCallRuleValidation] = React.useState(false)
  const [callRuleValidationMixed, setCallRuleValidationMixed] =
    React.useState(false)
  React.useEffect(() => {
    setOligoNameForward(well[0].name)
    setSequenceForward(well[0].sequence)
    setBaseCountForward(well[0].baseCount)
    setOligoNameReverse(well[1].name)
    setSequenceReverse(well[1].sequence)
    setBaseCountReverse(well[1].baseCount)
    setIsOverridenForward(well[0].isOverridden)
    setIsOverridenReverse(well[1].isOverridden)
    setIdForward(well[0].id)
    setIdReverse(well[1].id)
    if (well[0].id === 0) {
      setThreeModeValueTypeForward(modificationNone.none)
      setFiveModeValueTypeForward(modificationNone.none)
      setCallRuleValidation(false)
      dispatch({
        type: 'UPDATE_ERROR_RESPONSE',
        data: EmptyResponse,
      })
      dispatch({
        type: 'UPDATE_ERROR_DATA',
        data: {
          ...state.errorData,
          sequence: well[0].sequence,
          name: well[0].name,
          threeMod: modificationNone.none,
          fiveMod: modificationNone.none,
          pageNo: 2,
          isOverridden: well[0].isOverridden,
          wellType: well[0].wellType,
          mixed: well[0].mixed,
        },
      })
    } else {
      setThreeModeValueTypeForward(well[0].threeMod)
      setFiveModeValueTypeForward(well[0].fiveMod)
      setCallRuleValidation(true)
      dispatch({
        type: 'UPDATE_ERROR_RESPONSE',
        data: {
          ...state.errorResponseJson,
          listErrors: well[0].listError,
          listWarning: well[0].listWarning,
          baseCount: well[0].baseCount,
          molecularWeight: well[0].molecularWeight,
          primerDimer: well[0].primerDimer,
          meltingTemperature: well[0].meltingTemparature,
          secondaryStructure: well[0].secondaryStructure,
          gcContent: well[0].gcContent,
        },
      })
      dispatch({
        type: 'UPDATE_ERROR_DATA',
        data: {
          ...state.errorData,
          sequence: well[0].sequence,
          name: well[0].name,
          threeMod: well[0].threeMod,
          fiveMod: well[0].fiveMod,
          pageNo: 2,
          isOverridden: well[0].isOverridden,
          wellType: well[0].wellType,
          mixed: well[0].mixed,
        },
      })
    }
    if (well[1].id === 0) {
      setThreeModeValueTypeReverse(modificationNone.none)
      setFiveModeValueTypeReverse(modificationNone.none)
      setCallRuleValidationMixed(false)
      dispatch({
        type: 'UPDATE_ERROR_RESPONSE_MIXED',
        data: EmptyResponse,
      })
      dispatch({
        type: 'UPDATE_ERROR_DATA_MIXED',
        data: {
          ...state.errorDataMixed,
          sequence: well[1].sequence,
          name: well[1].name,
          threeMod: modificationNone.none,
          fiveMod: modificationNone.none,
          pageNo: 2,
          isOverridden: well[1].isOverridden,
          wellType: well[1].wellType,
          mixed: well[1].mixed,
        },
      })
    } else {
      setThreeModeValueTypeReverse(well[1].threeMod)
      setFiveModeValueTypeReverse(well[1].fiveMod)
      setCallRuleValidationMixed(true)
      dispatch({
        type: 'UPDATE_ERROR_RESPONSE_MIXED',
        data: {
          ...state.errorResponseJsonMixed,
          listErrors: well[1].listError,
          listWarning: well[1].listWarning,
          baseCount: well[1].baseCount,
          molecularWeight: well[1].molecularWeight,
          primerDimer: well[1].primerDimer,
          meltingTemperature: well[1].meltingTemparature,
          secondaryStructure: well[1].secondaryStructure,
          gcContent: well[1].gcContent,
        },
      })
      dispatch({
        type: 'UPDATE_ERROR_DATA_MIXED',
        data: {
          ...state.errorDataMixed,
          sequence: well[1].sequence,
          name: well[1].name,
          threeMod: well[1].threeMod,
          fiveMod: well[1].fiveMod,
          pageNo: 2,
          isOverridden: well[1].isOverridden,
          wellType: well[1].wellType,
          mixed: well[1].mixed,
        },
      })
    }

    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [well])

  const [ruleValidatePlate] = useRuleValidatePlateMutation()
  const [platesessionField] = usePlateSessionFieldMutation()
  const [nameValidation, setNameValidation] = React.useState<string[]>([])
  const [sequenceValidation, setSequenceValidation] = React.useState<string[]>(
    []
  )
  const [nameValidationReverse, setNameValidationReverse] = React.useState<
    string[]
  >([])
  const [sequenceValidationReverse, setSequenceValidationReverse] =
    React.useState<string[]>([])

  const [oligoNameWarning, setOligoNameWarning] = React.useState<string[]>([])
  const [oligoReverseWarning, setOligoReverseWarning] = React.useState<
    string[]
  >([])
  const seqInput: any = document.getElementById('sequence')
  const seqRevInput: any = document.getElementById('sequenceReverse')

  const ruleValidation = async (obj) => {
    const response = await ruleValidatePlate({
      variables: { input: obj, productInput: productDetails },
    })
    const { data } = response
    if (data && !data.ruleValidatePlate.serverError) {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: '',
      })
      dispatch({ type: 'UPDATE_ERROR_RESPONSE', data: data.ruleValidatePlate })
    } else {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: ConfiguratorValues.InternalServerError,
      })
    }
  }

  const ruleValidationMixed = async (obj) => {
    const response = await ruleValidatePlate({
      variables: { input: obj, productInput: productDetails },
    })
    const { data } = response
    if (data && !data.ruleValidatePlate.serverError) {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: '',
      })
      dispatch({
        type: 'UPDATE_ERROR_RESPONSE_MIXED',
        data: data.ruleValidatePlate,
      })
    } else {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: ConfiguratorValues.InternalServerError,
      })
    }
  }

  const savePlateDataToSession = async (obj) => {
    await platesessionField({
      variables: { input: obj, productInput: productDetails },
    })
  }
  const sequenceKey = messages.CONF_SEQUENCE_TEXT.defaultMessage
  const nameKey = messages.CONF_OLIGO_NAME_KEY.defaultMessage
  const checkValidationSequence = () => {
    const errorSequence: string[] = []
    setSequenceValidation([])
    const errorName: string[] = []
    setNameValidation([])
    const nameWarning: string[] = []
    setOligoNameWarning([])
    setBaseCountForward(state.errorResponseJson.baseCount)
    if (state.errorResponseJson) {
      state.errorResponseJson.listWarning.forEach((warning) => {
        if (warning.key === WarningKey.name) {
          nameWarning.push(intl.formatMessage(messages.CONF_OLIGO_NAME_WARNING))
        }
        if (warning.key === WarningKey.sequence) {
          nameWarning.push(warning.value)
        }
      })
      state.errorResponseJson.listErrors.forEach((obj) => {
        if (
          obj.key === sequenceKey ||
          obj.key === ConfiguratorValues.SequencePriority
        ) {
          errorSequence.push(obj.value)
        }
        if (obj.key === nameKey) {
          errorName.push(obj.value)
        }
      })
    }
    setOligoNameWarning(nameWarning)
    setNameValidation(errorName)
    setSequenceValidation(errorSequence)
  }
  const [updateWellLoading, setUpdateWellLoading] = React.useState(false)
  const rulevalidateAndSaveMixed = async (idReverse, error) => {
    let errormixed: any = []
    let warningMixed: any = []
    const response = await ruleValidatePlate({
      variables: { input: state.errorDataMixed, productInput: productDetails },
    })
    const { data } = response
    if (data && !data.ruleValidatePlate.serverError) {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: '',
      })
      errormixed = data.ruleValidatePlate?.listErrors
      warningMixed = data.ruleValidatePlate?.listWarning
      dispatch({
        type: 'UPDATE_ERROR_RESPONSE_MIXED',
        data: data.ruleValidatePlate,
      })
      let idMixed = idReverse
      const emptyWell = { ...emptyWellList }
      if (idReverse === 0) {
        sessionData[currentPlateIndex].wellList.push(emptyWell)
        sessionData[currentPlateIndex].wellList.forEach((wellMixed) => {
          if (wellMixed.id === 0) {
            idGeneration.forEach((id) => {
              if (id.key === row) {
                wellMixed.id = 96 + id.value + parseInt(col, 10)
                idMixed = 96 + id.value + parseInt(col, 10)
                setIdReverse(96 + id.value + parseInt(col, 10))
                wellMixed.mixed = id.value + parseInt(col, 10)
              }
            })
            wellMixed.countryCode = sessionData[currentPlateIndex].countryCode
            wellMixed.productType = productDetails.productType
            wellMixed.wellType = sessionData[currentPlateIndex].wellType
            wellMixed.row = row
            wellMixed.column = col
            delete wellMixed.__typename
          }
        })
      }
      sessionData[currentPlateIndex].countOfWells =
        sessionData[currentPlateIndex].wellList.length
      sessionData[currentPlateIndex].wellList.forEach((wells) => {
        if (wells.row === row && wells.column === col && wells.id === idMixed) {
          wells.isOverridden = isOverridenReverse
          wells.name = oligoNameReverse
          wells.sequence = sequenceReverse
          wells.threeMod = threeModeValueTypeReverse
          wells.fiveMod = fiveModeValueTypeReverse
          wells.baseCount = data.ruleValidatePlate.baseCount
            ? data.ruleValidatePlate.baseCount
            : sequenceReverse.split(' ').join('').length
          wells.technicalSequence = data.ruleValidatePlate.technicalSequence
          errormixed.forEach((error) => {
            delete error.__typename
          })
          warningMixed.forEach((warning) => {
            delete warning.__typename
          })
          wells.listError = errormixed
          wells.listWarning = warningMixed
          if (data?.ruleValidatePlate?.molecularWeight) {
            wells.molecularWeight = data.ruleValidatePlate.molecularWeight
          }
          if (data?.ruleValidatePlate?.primerDimer) {
            wells.primerDimer = data.ruleValidatePlate.primerDimer
          }
          if (data?.ruleValidatePlate?.secondaryStructure) {
            wells.secondaryStructure = data.ruleValidatePlate.secondaryStructure
          }
          if (data?.ruleValidatePlate?.gcContent) {
            wells.gcContent = data.ruleValidatePlate.gcContent
          }
          if (data?.ruleValidatePlate?.meltingTemperature) {
            wells.meltingTemparature = data.ruleValidatePlate.meltingTemperature
          }
        }
      })
      sessionData.forEach((data) => {
        data.pageNo = 1
      })
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
      dispatch({ type: 'SET_STEP_NO', data: 1 })
      savePlateDataToSession(sessionData)
      setUpdateWellLoading(false)
      if (errormixed.length === 0 && error.length === 0) {
        updatedData()
      }
    } else {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: ConfiguratorValues.InternalServerError,
      })
    }
  }

  const rulevalidateAndSave = async (idForward) => {
    setUpdateWellLoading(true)
    dispatch({ type: 'SET_MINIMUM_WELLS_ERROR', data: false })
    let error: any = []
    let warning: any = []
    const response = await ruleValidatePlate({
      variables: { input: state.errorData, productInput: productDetails },
    })
    const { data } = response
    if (data && !data.ruleValidatePlate.serverError) {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: '',
      })
      error = data.ruleValidatePlate?.listErrors
      warning = data.ruleValidatePlate?.listWarning
      dispatch({ type: 'UPDATE_ERROR_RESPONSE', data: data.ruleValidatePlate })
      let idStandard = idForward
      if (idForward === 0) {
        const emptyWell = { ...emptyWellList }
        sessionData[currentPlateIndex].wellList.push(emptyWell)
        sessionData[currentPlateIndex].wellList.forEach((wellStandard) => {
          if (wellStandard.id === 0) {
            idGeneration.forEach((id) => {
              if (id.key === row) {
                wellStandard.id = id.value + parseInt(col, 10)
                idStandard = id.value + parseInt(col, 10)
                setIdForward(id.value + parseInt(col, 10))
                wellStandard.mixed = id.value + parseInt(col, 10)
              }
            })
            wellStandard.countryCode =
              sessionData[currentPlateIndex].countryCode
            wellStandard.productType = productDetails.productType
            wellStandard.wellType = sessionData[currentPlateIndex].wellType

            wellStandard.row = row
            wellStandard.column = col
            delete wellStandard.__typename
          }
        })
      }
      sessionData[currentPlateIndex].countOfWells =
        sessionData[currentPlateIndex].wellList.length
      sessionData[currentPlateIndex].wellList.forEach((wells) => {
        if (
          wells.row === row &&
          wells.column === col &&
          wells.id === idStandard
        ) {
          wells.isOverridden = isOverridenForward
          wells.name = oligoNameForward
          wells.sequence = sequenceForward
          wells.threeMod = threeModeValueTypeForward
          wells.fiveMod = fiveModeValueTypeForward
          wells.baseCount = data.ruleValidatePlate.baseCount
            ? data.ruleValidatePlate.baseCount
            : sequenceForward.split(' ').join('').length
          wells.technicalSequence = data.ruleValidatePlate.technicalSequence
          error.forEach((error) => {
            delete error.__typename
          })
          warning.forEach((warn) => {
            delete warn.__typename
          })
          wells.listError = error
          wells.listWarning = warning
          if (data?.ruleValidatePlate?.molecularWeight) {
            wells.molecularWeight = data.ruleValidatePlate.molecularWeight
          }
          if (data?.ruleValidatePlate?.primerDimer) {
            wells.primerDimer = data.ruleValidatePlate.primerDimer
          }
          if (data?.ruleValidatePlate?.gcContent) {
            wells.gcContent = data.ruleValidatePlate.gcContent
          }
          if (data?.ruleValidatePlate?.secondaryStructure) {
            wells.secondaryStructure = data.ruleValidatePlate.secondaryStructure
          }
          if (data?.ruleValidatePlate?.meltingTemperature) {
            wells.meltingTemparature = data.ruleValidatePlate.meltingTemperature
          }
        }
      })
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
      rulevalidateAndSaveMixed(idReverse, error)
    } else {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: ConfiguratorValues.InternalServerError,
      })
    }
  }

  React.useEffect(() => {
    checkValidationSequence()
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.errorResponseJson])

  React.useEffect(() => {
    if (callRuleValidation) {
      setCallRuleValidation(false)
      if (
        oligoNameForward !== '' ||
        sequenceForward !== '' ||
        idForward !== 0
      ) {
        ruleValidation(state.errorData)
      } else {
        dispatch({
          type: 'UPDATE_ERROR_RESPONSE',
          data: EmptyResponse,
        })
      }
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.errorData])

  const checkValidationSequenceMixed = () => {
    const errorSequenceReverse: string[] = []
    setSequenceValidationReverse([])
    const errorNameReverse: string[] = []
    setNameValidationReverse([])
    const nameReverseWarning: string[] = []
    setOligoReverseWarning([])
    setBaseCountReverse(state.errorResponseJsonMixed.baseCount)
    if (state.errorResponseJsonMixed) {
      state.errorResponseJsonMixed.listWarning.forEach((warning) => {
        if (warning.key === WarningKey.name) {
          nameReverseWarning.push(
            intl.formatMessage(messages.CONF_OLIGO_NAME_WARNING)
          )
        }
        if (warning.key === WarningKey.sequence) {
          nameReverseWarning.push(warning.value)
        }
      })
      state.errorResponseJsonMixed.listErrors.forEach((obj) => {
        if (
          obj.key === sequenceKey ||
          obj.key === ConfiguratorValues.SequencePriority
        ) {
          errorSequenceReverse.push(obj.value)
        }
        if (obj.key === nameKey) {
          errorNameReverse.push(obj.value)
        }
      })
    }
    setOligoReverseWarning(nameReverseWarning)
    setNameValidationReverse(errorNameReverse)
    setSequenceValidationReverse(errorSequenceReverse)
  }

  React.useEffect(() => {
    checkValidationSequenceMixed()
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.errorResponseJsonMixed])

  React.useEffect(() => {
    if (callRuleValidationMixed) {
      setCallRuleValidationMixed(false)
      if (
        oligoNameReverse !== '' ||
        sequenceReverse !== '' ||
        idReverse !== 0
      ) {
        ruleValidationMixed(state.errorDataMixed)
      } else {
        dispatch({
          type: 'UPDATE_ERROR_RESPONSE_MIXED',
          data: EmptyResponse,
        })
      }
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.errorDataMixed])

  React.useEffect(() => {
    if (seqRevInput) {
      seqRevInput.selectionEnd = insertPosReverse
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sequenceReverse])

  React.useEffect(
    () => {
      if (callDebounceReverseCall) {
        setCallDebounceReverseCall(false)
        dispatch({
          type: 'UPDATE_ERROR_DATA_MIXED',
          data: {
            ...state.errorDataMixed,
            sequence: debouncedSequenceReverseData,
          },
        })
      }
    },
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedSequenceReverseData]
  )
  React.useEffect(
    () => {
      if (callDebounceNameReverse) {
        setCallDebounceNameReverse(false)
        dispatch({
          type: 'UPDATE_ERROR_DATA_MIXED',
          data: { ...state.errorDataMixed, name: debouncedNameReverseData },
        })
      }
    },
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedNameReverseData]
  )
  React.useEffect(
    () => {
      if (callNameDebounce) {
        setCallNameDebounce(false)
        dispatch({
          type: 'UPDATE_ERROR_DATA',
          data: { ...state.errorData, name: debouncedNameForwardData },
        })
      }
    },
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedNameForwardData]
  )
  const handleName = (value, type) => {
    value = validateText(convertToASCII(value))
    if (type === 0) {
      setCallRuleValidation(true)
      setCallNameDebounce(true)
      setOligoNameForward(value)
    } else if (type === 1) {
      setCallRuleValidationMixed(true)
      setCallDebounceNameReverse(true)
      setOligoNameReverse(value)
    }
  }

  React.useEffect(() => {
    if (seqInput) {
      seqInput.selectionEnd = insertPos
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sequenceForward])

  React.useEffect(
    () => {
      if (callDebounceCall) {
        setCallDebounceCall(false)
        dispatch({
          type: 'UPDATE_ERROR_DATA',
          data: { ...state.errorData, sequence: debouncedSequenceData },
        })
      }
    },
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedSequenceData]
  )

  const handleSequence = (value, type) => {
    value = validateText(convertToASCII(value))
    if (type === 0) {
      setCallRuleValidation(true)
      insertPos = seqInput.selectionStart
      setBaseCountForward(sequenceCount(value))
      setCallDebounceCall(true)
      setSequenceForward(formatSequence(value))
    } else if (type === 1) {
      setCallRuleValidationMixed(true)
      insertPosReverse = seqRevInput.selectionStart
      setBaseCountReverse(sequenceCount(value))
      setCallDebounceReverseCall(true)
      setSequenceReverse(formatSequence(value))
    }
  }

  const handleThreeMod = (value, type) => {
    if (type === 0) {
      setCallRuleValidation(true)
      setThreeModeValueTypeForward(value)
      dispatch({
        type: 'UPDATE_ERROR_DATA',
        data: { ...state.errorData, threeMod: value },
      })
    } else if (type === 1) {
      setCallRuleValidationMixed(true)
      setThreeModeValueTypeReverse(value)
      dispatch({
        type: 'UPDATE_ERROR_DATA_MIXED',
        data: { ...state.errorDataMixed, threeMod: value },
      })
    }
  }

  const handleFiveMod = (value, type) => {
    if (type === 0) {
      setCallRuleValidation(true)
      setFiveModeValueTypeForward(value)
      dispatch({
        type: 'UPDATE_ERROR_DATA',
        data: { ...state.errorData, fiveMod: value },
      })
    } else if (type === 1) {
      setCallRuleValidationMixed(true)
      setFiveModeValueTypeReverse(value)
      dispatch({
        type: 'UPDATE_ERROR_DATA_MIXED',
        data: { ...state.errorDataMixed, fiveMod: value },
      })
    }
  }
  const handleOverride = (value, type) => {
    if (type === 0) {
      setCallRuleValidation(true)
      setIsOverridenForward(value)
      dispatch({
        type: 'UPDATE_ERROR_DATA',
        data: { ...state.errorData, isOverridden: value },
      })
    } else if (type === 1) {
      setCallRuleValidationMixed(true)
      setIsOverridenReverse(value)
      dispatch({
        type: 'UPDATE_ERROR_DATA_MIXED',
        data: { ...state.errorDataMixed, isOverridden: value },
      })
    }
  }
  const clearWell = () => {
    setDialogOpen(true)
  }
  const deleteItems = (item, type) => {
    dispatch({ type: 'SET_MINIMUM_WELLS_ERROR', data: false })
    if (type === 'SelectedWell') {
      let clearSession = false
      sessionData[currentPlateIndex].wellList.forEach((item) => {
        if (item.row === row && item.column === col && item.id === idForward) {
          const index = sessionData[currentPlateIndex].wellList.indexOf(item)
          if (index !== -1) {
            sessionData[currentPlateIndex].wellList.splice(index, 1)
          }
        }
      })
      sessionData[currentPlateIndex].wellList.forEach((item) => {
        if (item.row === row && item.column === col && item.id === idReverse) {
          const index = sessionData[currentPlateIndex].wellList.indexOf(item)
          if (index !== -1) {
            sessionData[currentPlateIndex].wellList.splice(index, 1)
          }
        }
      })
      sessionData[currentPlateIndex].countOfWells =
        sessionData[currentPlateIndex].wellList.length

      if (sessionData[currentPlateIndex].wellList.length === 0) {
        if (sessionData.length === 1) {
          sessionData.splice(0, sessionData.length)
          state.sessionData.push(EmptyState)
          sessionData.forEach((data) => {
            delete data.__typename
            data.wellList.forEach((well) => {
              delete well.__typename
            })
            data.biTubeWellList.forEach((duplexwell) => {
              delete duplexwell.__typename
            })
          })
          dispatch({
            type: 'UPDATE_CURRENT_PLATE_INDEX',
            data: 0,
          })
          dispatch({
            type: 'UPDATE_INPUT',
            data: [...state.sessionData],
          })
          clearSession = true
          savePlateDataToSession([])
          dispatch({
            type: 'SET_STEP_NO',
            data: 0,
          })
          const url = `${dnaPlatesRoute.index()}?product=${
            productDetails.productType
          }&activeLink=${ActiveLinkTypeDnaplate.SequenceUpload}`
          router.push(url)
        } else {
          const item = sessionData[currentPlateIndex]
          let idChanged = false
          if (
            item.plateId - 1 === state.currentPlateIndex &&
            sessionData.length - 1 === state.currentPlateIndex &&
            sessionData.length !== 1
          ) {
            dispatch({
              type: 'UPDATE_CURRENT_PLATE_INDEX',
              data: state.currentPlateIndex - 1,
            })
          }
          sessionData.forEach((plate) => {
            if (plate.plateId > item.plateId) {
              plate.plateId = plate.plateId - 1
              idChanged = true
            }
          })
          const index = sessionData.indexOf(item)
          if (index !== -1) {
            sessionData.splice(index, 1)
          }
          if (idChanged) {
            dispatch({
              type: 'IS_PLATE_DELETED',
              data: !state.isPlateDeleted,
            })
          }
        }
      }
      if (!clearSession) {
        sessionData.forEach((data) => {
          data.pageNo = 1
        })
        dispatch({ type: 'SET_STEP_NO', data: 1 })
        dispatch({
          type: 'UPDATE_INPUT',
          data: [...state.sessionData],
        })
        savePlateDataToSession(sessionData)
      }

      setOligoNameForward('')
      setOligoNameReverse('')
      setSequenceForward('')
      setSequenceReverse('')
      setThreeModeValueTypeForward('')
      setThreeModeValueTypeReverse('')
      setFiveModeValueTypeForward('')
      setFiveModeValueTypeReverse('')
      setIsOverridenForward(false)
      setIsOverridenReverse(false)
      setIdForward(0)
      setIdReverse(0)
      dispatch({
        type: 'UPDATE_ERROR_RESPONSE',
        data: EmptyResponse,
      })
      dispatch({
        type: 'UPDATE_ERROR_RESPONSE_MIXED',
        data: EmptyResponse,
      })
    }
    updatedData()
  }
  const handleClose = () => {
    updatedData()
  }
  const renderMixedData = (modificationsResponseData) => {
    const result: any[] = []
    result.push(
      <div>
        <Box>
          <Grid container className={classes.conainerSpacing}>
            <Grid item xs={6}>
              <div>
                <Grid container>
                  <Grid item xs={7}>
                    <h2 className={classes.oligoName}>
                      <FormattedMessage
                        {...messages.CONF_DNAPLATES_FORWARD_OLIGO}
                      />
                    </h2>
                  </Grid>
                  <Grid item xs={5}>
                    <div className={classes.overrideMargin}>
                      {productDetails.isCSRSupervisor === true ? (
                        <FormControlLabel
                          classes={{
                            label: classes.over1,
                            root: classes.marginRoot,
                          }}
                          control={
                            <Checkbox
                              value={isOverridenForward}
                              color="primary"
                              checked={isOverridenForward}
                              onChange={() => {
                                handleOverride(!isOverridenForward, 0)
                              }}
                              className={classes.overrideCheckBox}
                            />
                          }
                          label={
                            messages.CONF_OVERRIDE_VALIDATION.defaultMessage
                          }
                        />
                      ) : (
                        ''
                      )}
                    </div>
                  </Grid>
                </Grid>
                <Grid className={classes.seqPad} container spacing={6}>
                  <Grid item xs={4} className={classes.sideHeadingMargin}>
                    <FormLabel
                      className={clsx(
                        classes.TextFontRes,
                        classes.subheadColor
                      )}
                    >
                      <FormattedMessage
                        {...messages.CONF_OLIGO_NAME_standard}
                      />
                    </FormLabel>
                  </Grid>
                  <Grid item xs={8}>
                    <Field
                      name="oligoNameForward"
                      size="small"
                      fullWidth={false}
                      component={LiquidInputAdapter}
                      spellcheck={'false'}
                      filled
                      className={classes.textWidth}
                      value={oligoNameForward}
                      onChange={(e) => {
                        handleName(e.target.value, 0)
                      }}
                    />
                    <div
                      className={clsx(
                        classes.nameHelpText,
                        GlobalCSS.globalHelpTextColor
                      )}
                    >
                      <FormattedMessage
                        {...messages.CONF_DNAPLATE_OLIGONAME_HELPTEXT}
                      />
                    </div>
                    <div>
                      <ValidationErrors errors={nameValidation} />
                    </div>
                  </Grid>
                  <Grid item xs={4} className={classes.sideHeadingMargin}>
                    <FormLabel
                      className={clsx(
                        classes.TextFontRes,
                        classes.subheadColor
                      )}
                    >
                      <FormattedMessage {...messages.CONF_DNAPLATES_SEQUENCE} />
                    </FormLabel>
                  </Grid>
                  <Grid item xs={8}>
                    <Field
                      name="sequence"
                      size="small"
                      fullWidth={false}
                      component={LiquidInputAdapter}
                      spellcheck={'false'}
                      filled
                      multiline
                      autoComplete="off"
                      className={clsx(classes.textWidthSequence)}
                      value={sequenceForward}
                      onChange={(e) => {
                        handleSequence(e.target.value, 0)
                      }}
                    />
                    <div
                      className={clsx(
                        classes.nameHelpText,
                        GlobalCSS.globalHelpTextColor
                      )}
                    >
                      {sessionData[0].wellType === PlateProduct.wellType96 &&
                      productDetails.countryCode === CountryCodes.JP
                        ? intl.formatMessage(
                            messages.CONF_DNAPLATE_JP_96WELLTYPE_MIXED_PLACEHOLDER
                          )
                        : instructions}
                    </div>
                    <div>
                      <ValidationErrors errors={sequenceValidation} />
                    </div>
                  </Grid>
                  <Grid item xs={4} className={classes.sideHeadingMargin}>
                    <FormLabel
                      className={clsx(
                        classes.TextFontRes,
                        sequenceForward.length !== 0 &&
                          sequenceValidation.length === 0
                          ? classes.subheadColor
                          : classes.disableMod
                      )}
                    >
                      <FormattedMessage
                        {...messages.CONF_DNAPLATES_MODIFICATIONS}
                      />
                    </FormLabel>
                  </Grid>
                  <Grid item xs={4}>
                    <Field
                      name="modificationTypeFiveMod"
                      component={LiquidSelectAdapter}
                      label="5'"
                      options={[
                        ...modificationTypeValueWithProperties(
                          DefaultValue.FiveModiFication,
                          DefaultValue.Category,
                          modificationsResponseData,
                          state.errorResponseJson.listFiveMod
                        ),
                      ]}
                      value={fiveModeValueTypeForward}
                      onChange={(e) => handleFiveMod(e.target.value, 0)}
                      filled
                      className={classes.modificationsWidth}
                      disabled={
                        sequenceForward.length !== 0 &&
                        sequenceValidation.length === 0
                          ? false
                          : true
                      }
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Field
                      name="modificationTypeThreeMod"
                      component={LiquidSelectAdapter}
                      label="3'"
                      options={[
                        ...modificationTypeValueWithProperties(
                          DefaultValue.ThreeModification,
                          DefaultValue.Category,
                          modificationsResponseData,
                          state.errorResponseJson.listThreeMod
                        ),
                      ]}
                      value={threeModeValueTypeForward}
                      onChange={(e) => handleThreeMod(e.target.value, 0)}
                      filled
                      className={classes.modificationsWidth}
                      disabled={
                        sequenceForward.length !== 0 &&
                        sequenceValidation.length === 0
                          ? false
                          : true
                      }
                    />
                  </Grid>
                  <Divider />
                  <Grid item xs={4}>
                    <FormLabel
                      className={clsx(classes.textAlign, classes.subheadColor)}
                    >
                      <FormattedMessage
                        {...messages.CONF_DNAPLATES_OLIGO_PREVIEW}
                      />
                    </FormLabel>
                  </Grid>
                  <Grid
                    className={clsx(classes.textWidth, classes.wordWrap)}
                    item
                    xs={8}
                  >
                    {sequenceForward.length === 0 ? (
                      <FormLabel className={clsx(classes.emptyPreview)}>
                        <FormattedMessage
                          {...messages.CONF_SEQUENCE_PREVIEW_HELP_TEXT}
                        />
                      </FormLabel>
                    ) : sequenceValidation.length === 0 ? (
                      <FormLabel
                        className={clsx(classes.subheadColor, classes.preview)}
                      >
                        {fiveModeValueTypeForward !== modificationNone.none
                          ? fiveModeValueTypeForward
                          : ''}
                        {sequenceForward}
                        {threeModeValueTypeForward !== modificationNone.none
                          ? threeModeValueTypeForward
                          : ''}
                      </FormLabel>
                    ) : (
                      <FormLabel
                        className={clsx(classes.subheadColor, classes.preview)}
                      >
                        {'--'}
                      </FormLabel>
                    )}
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid item xs={1}>
              <div>
                <Divider className={classes.divider} orientation="vertical" />
              </div>
            </Grid>

            <Grid item xs={5}>
              <div className={classes.leftMargin}>
                <h2 className={classes.oligoPadLeft}>
                  <FormattedMessage
                    {...messages.CONF_DNAPLATES_FORWARD_OLIGO_PROPERTIES}
                  />
                </h2>

                <Grid className={classes.oligoPad}>
                  <Grid
                    container
                    spacing={3}
                    className={classes.marginProperties}
                  >
                    <Grid item xs={7}>
                      <FormLabel
                        className={clsx(
                          classes.propertiesPadding,
                          classes.subheadColor
                        )}
                      >
                        <FormattedMessage
                          {...messages.CONF_DNAPLATES_MOLECULAR_WEIGHT}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item xs={4}>
                      <FormLabel>
                        {sequenceForward.length !== 0 &&
                        sequenceValidation.length === 0
                          ? state.errorResponseJson.molecularWeight
                          : '--'}
                      </FormLabel>
                    </Grid>
                    <Grid item xs={7}>
                      <FormLabel
                        className={clsx(
                          classes.propertiesPadding,
                          classes.subheadColor
                        )}
                      >
                        <FormattedMessage
                          {...messages.CONF_DNAPLATES_SECOUNDARY_STRUCTURE}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item xs={4}>
                      <FormLabel>
                        {sequenceForward.length !== 0 &&
                        sequenceValidation.length === 0
                          ? messages[state.errorResponseJson.secondaryStructure]
                              ?.defaultMessage ||
                            state.errorResponseJson.secondaryStructure
                          : '--'}
                      </FormLabel>
                    </Grid>
                    <Grid item xs={7}>
                      <FormLabel
                        className={clsx(
                          classes.propertiesPadding,
                          classes.subheadColor
                        )}
                      >
                        <FormattedMessage
                          {...messages.CONF_DNAPLATES_MELTING_TEMPERATURE}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item xs={4}>
                      <FormLabel>
                        {sequenceForward.length !== 0 &&
                        sequenceValidation.length === 0
                          ? state.errorResponseJson.meltingTemperature
                          : '--'}
                      </FormLabel>
                    </Grid>
                    <Grid item xs={7}>
                      <FormLabel
                        className={clsx(
                          classes.propertiesPadding,
                          classes.subheadColor
                        )}
                      >
                        <FormattedMessage {...messages.CONF_BASE_COUNT} />
                      </FormLabel>
                    </Grid>
                    <Grid item xs={4}>
                      <FormLabel>
                        {sequenceForward.length !== 0 &&
                        sequenceValidation.length === 0
                          ? baseCountForward
                          : '--'}
                      </FormLabel>
                    </Grid>
                    <Grid item xs={7}>
                      <FormLabel
                        className={clsx(
                          classes.propertiesPadding,
                          classes.subheadColor
                        )}
                      >
                        <FormattedMessage
                          {...messages.CONF_DNAPLATES_GC_CONTENT}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item xs={4}>
                      <FormLabel>
                        {sequenceForward.length !== 0 &&
                        sequenceValidation.length === 0
                          ? state.errorResponseJson.gcContent
                          : '--'}
                      </FormLabel>
                    </Grid>
                    <Grid item xs={7}>
                      <FormLabel
                        className={clsx(
                          classes.propertiesPadding,
                          classes.subheadColor
                        )}
                      >
                        <FormattedMessage
                          {...messages.CONF_DNAPLATES_PRIMER_DIMER}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item xs={4}>
                      <FormLabel>
                        {sequenceForward.length !== 0 &&
                        sequenceValidation.length === 0
                          ? state.errorResponseJson.primerDimer
                          : '--'}
                      </FormLabel>
                    </Grid>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </Box>
        <div>
          <ValidationWarnings warnings={oligoReverseWarning} />
        </div>
        <Box>
          <Grid container className={classes.conainerSpacing}>
            <Grid item xs={6}>
              <div>
                <Grid container>
                  <Grid item xs={7}>
                    <h2 className={classes.oligoName}>
                      <FormattedMessage
                        {...messages.CONF_DNAPLATES_REVERSE_OLIGO}
                      />
                    </h2>
                  </Grid>
                  <Grid item xs={5}>
                    <div className={classes.overrideMargin}>
                      {productDetails.isCSRSupervisor === true ? (
                        <FormControlLabel
                          classes={{
                            label: classes.over1,
                            root: classes.marginRoot,
                          }}
                          control={
                            <Checkbox
                              value={isOverridenReverse}
                              color="primary"
                              checked={isOverridenReverse}
                              onChange={() => {
                                handleOverride(!isOverridenReverse, 1)
                              }}
                              className={classes.overrideCheckBox}
                            />
                          }
                          label={
                            messages.CONF_OVERRIDE_VALIDATION.defaultMessage
                          }
                        />
                      ) : (
                        ''
                      )}
                    </div>
                  </Grid>
                </Grid>
                <Grid className={classes.seqPad} container spacing={6}>
                  <Grid item xs={4} className={classes.sideHeadingMargin}>
                    <FormLabel
                      className={clsx(
                        classes.TextFontRes,
                        classes.subheadColor
                      )}
                    >
                      <FormattedMessage
                        {...messages.CONF_OLIGO_NAME_standard}
                      />
                    </FormLabel>
                  </Grid>
                  <Grid item xs={8}>
                    <Field
                      name="oligoNameReverse"
                      size="small"
                      fullWidth={false}
                      component={LiquidInputAdapter}
                      spellcheck={'false'}
                      filled
                      className={classes.textWidth}
                      value={oligoNameReverse}
                      onChange={(e) => {
                        handleName(e.target.value, 1)
                      }}
                    />
                    <div
                      className={clsx(
                        classes.nameHelpText,
                        GlobalCSS.globalHelpTextColor
                      )}
                    >
                      <FormattedMessage
                        {...messages.CONF_DNAPLATE_OLIGONAME_HELPTEXT}
                      />
                    </div>
                    <div>
                      <ValidationErrors errors={nameValidationReverse} />
                    </div>
                  </Grid>
                  <Grid item xs={4} className={classes.sideHeadingMargin}>
                    <FormLabel
                      className={clsx(
                        classes.TextFontRes,
                        classes.subheadColor
                      )}
                    >
                      <FormattedMessage {...messages.CONF_DNAPLATES_SEQUENCE} />
                    </FormLabel>
                  </Grid>
                  <Grid item xs={8}>
                    <Field
                      name="sequenceReverse"
                      size="small"
                      fullWidth={false}
                      component={LiquidInputAdapter}
                      spellcheck={'false'}
                      filled
                      multiline
                      autoComplete="off"
                      className={clsx(classes.textWidthSequence)}
                      value={sequenceReverse}
                      onChange={(e) => {
                        handleSequence(e.target.value, 1)
                      }}
                    />
                    <div
                      className={clsx(
                        classes.nameHelpText,
                        GlobalCSS.globalHelpTextColor
                      )}
                    >
                      {sessionData[0].wellType === PlateProduct.wellType96 &&
                      productDetails.countryCode === CountryCodes.JP
                        ? intl.formatMessage(
                            messages.CONF_DNAPLATE_JP_96WELLTYPE_MIXED_PLACEHOLDER
                          )
                        : instructions}
                    </div>
                    <div>
                      <ValidationErrors errors={sequenceValidationReverse} />
                    </div>
                  </Grid>
                  <Grid item xs={4} className={classes.sideHeadingMargin}>
                    <FormLabel
                      className={clsx(
                        classes.TextFontRes,
                        sequenceReverse.length !== 0 &&
                          sequenceValidationReverse.length === 0
                          ? classes.subheadColor
                          : classes.disableMod
                      )}
                    >
                      <FormattedMessage
                        {...messages.CONF_DNAPLATES_MODIFICATIONS}
                      />
                    </FormLabel>
                  </Grid>
                  <Grid item xs={4}>
                    <Field
                      name="modificationTypeFiveModReverse"
                      component={LiquidSelectAdapter}
                      label="5'"
                      options={[
                        ...modificationTypeValueWithProperties(
                          DefaultValue.FiveModiFication,
                          DefaultValue.Category,
                          modificationsResponseData,
                          state.errorResponseJsonMixed.listFiveMod
                        ),
                      ]}
                      value={fiveModeValueTypeReverse}
                      onChange={(e) => handleFiveMod(e.target.value, 1)}
                      filled
                      className={classes.modificationsWidth}
                      disabled={
                        sequenceReverse.length !== 0 &&
                        sequenceValidationReverse.length === 0
                          ? false
                          : true
                      }
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Field
                      name="modificationTypeThreeModReverse"
                      component={LiquidSelectAdapter}
                      label="3'"
                      options={[
                        ...modificationTypeValueWithProperties(
                          DefaultValue.ThreeModification,
                          DefaultValue.Category,
                          modificationsResponseData,
                          state.errorResponseJsonMixed.listThreeMod
                        ),
                      ]}
                      value={threeModeValueTypeReverse}
                      onChange={(e) => handleThreeMod(e.target.value, 1)}
                      filled
                      className={classes.modificationsWidth}
                      disabled={
                        sequenceReverse.length !== 0 &&
                        sequenceValidationReverse.length === 0
                          ? false
                          : true
                      }
                    />
                  </Grid>
                  <Divider />
                  <Grid item xs={4}>
                    <FormLabel
                      className={clsx(classes.textAlign, classes.subheadColor)}
                    >
                      <FormattedMessage
                        {...messages.CONF_DNAPLATES_OLIGO_PREVIEW}
                      />
                    </FormLabel>
                  </Grid>
                  <Grid
                    className={clsx(classes.textWidth, classes.wordWrap)}
                    item
                    xs={8}
                  >
                    {sequenceReverse.length === 0 ? (
                      <FormLabel className={clsx(classes.emptyPreview)}>
                        <FormattedMessage
                          {...messages.CONF_SEQUENCE_PREVIEW_HELP_TEXT}
                        />
                      </FormLabel>
                    ) : sequenceValidationReverse.length === 0 ? (
                      <FormLabel
                        className={clsx(classes.subheadColor, classes.preview)}
                      >
                        {fiveModeValueTypeReverse !== modificationNone.none
                          ? fiveModeValueTypeReverse
                          : ''}
                        {sequenceReverse}
                        {threeModeValueTypeReverse !== modificationNone.none
                          ? threeModeValueTypeReverse
                          : ''}
                      </FormLabel>
                    ) : (
                      <FormLabel
                        className={clsx(classes.subheadColor, classes.preview)}
                      >
                        {'--'}
                      </FormLabel>
                    )}
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid item xs={1}>
              <div>
                <Divider className={classes.divider} orientation="vertical" />
              </div>
            </Grid>

            <Grid item xs={5}>
              <div className={classes.leftMargin}>
                <h2 className={classes.oligoPadLeft}>
                  <FormattedMessage
                    {...messages.CONF_DNAPLATES_REVERSE_OLIGO_PROPERTIES}
                  />
                </h2>

                <Grid className={classes.oligoPad}>
                  <Grid
                    container
                    spacing={3}
                    className={classes.marginProperties}
                  >
                    <Grid item xs={7}>
                      <FormLabel
                        className={clsx(
                          classes.propertiesPadding,
                          classes.subheadColor
                        )}
                      >
                        <FormattedMessage
                          {...messages.CONF_DNAPLATES_MOLECULAR_WEIGHT}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item xs={4}>
                      <FormLabel>
                        {sequenceReverse.length !== 0 &&
                        sequenceValidationReverse.length === 0
                          ? state.errorResponseJsonMixed.molecularWeight
                          : '--'}
                      </FormLabel>
                    </Grid>
                    <Grid item xs={7}>
                      <FormLabel
                        className={clsx(
                          classes.propertiesPadding,
                          classes.subheadColor
                        )}
                      >
                        <FormattedMessage
                          {...messages.CONF_DNAPLATES_SECOUNDARY_STRUCTURE}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item xs={4}>
                      <FormLabel>
                        {sequenceReverse.length !== 0 &&
                        sequenceValidationReverse.length === 0
                          ? messages[
                              state.errorResponseJsonMixed.secondaryStructure
                            ]?.defaultMessage ||
                            state.errorResponseJsonMixed.secondaryStructure
                          : '--'}
                      </FormLabel>
                    </Grid>
                    <Grid item xs={7}>
                      <FormLabel
                        className={clsx(
                          classes.propertiesPadding,
                          classes.subheadColor
                        )}
                      >
                        <FormattedMessage
                          {...messages.CONF_DNAPLATES_MELTING_TEMPERATURE}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item xs={4}>
                      <FormLabel>
                        {sequenceReverse.length !== 0 &&
                        sequenceValidationReverse.length === 0
                          ? state.errorResponseJsonMixed.meltingTemperature
                          : '--'}
                      </FormLabel>
                    </Grid>
                    <Grid item xs={7}>
                      <FormLabel
                        className={clsx(
                          classes.propertiesPadding,
                          classes.subheadColor
                        )}
                      >
                        <FormattedMessage {...messages.CONF_BASE_COUNT} />
                      </FormLabel>
                    </Grid>
                    <Grid item xs={4}>
                      <FormLabel>
                        {sequenceReverse.length !== 0 &&
                        sequenceValidationReverse.length === 0
                          ? baseCountReverse
                          : ' --'}
                      </FormLabel>
                    </Grid>
                    <Grid item xs={7}>
                      <FormLabel
                        className={clsx(
                          classes.propertiesPadding,
                          classes.subheadColor
                        )}
                      >
                        <FormattedMessage
                          {...messages.CONF_DNAPLATES_GC_CONTENT}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item xs={4}>
                      <FormLabel>
                        {sequenceReverse.length !== 0 &&
                        sequenceValidationReverse.length === 0
                          ? state.errorResponseJsonMixed.gcContent
                          : '--'}
                      </FormLabel>
                    </Grid>
                    <Grid item xs={7}>
                      <FormLabel
                        className={clsx(
                          classes.propertiesPadding,
                          classes.subheadColor
                        )}
                      >
                        <FormattedMessage
                          {...messages.CONF_DNAPLATES_PRIMER_DIMER}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item xs={4}>
                      <FormLabel>
                        {sequenceReverse.length !== 0 &&
                        sequenceValidationReverse.length === 0
                          ? state.errorResponseJsonMixed.primerDimer
                          : '--'}
                      </FormLabel>
                    </Grid>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </Box>
      </div>
    )
    return result
  }
  return (
    <div className={classes.root}>
      <Box>
        <Formik
          initialValues={INITIAL_VALUES}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              actions.setSubmitting(false)
            }, 1000)
          }}
        >
          {() => (
            <>
              <div>
                <Paper className={classes.oligoMargin}>
                  <Grid className={classes.closeIcon}>
                    <IconButton
                      className={classes.clearButton}
                      color="primary"
                      onClick={handleClose}
                    >
                      <ClearIcon fontSize="inherit" />
                    </IconButton>
                  </Grid>
                  <div>
                    <h2 className={classes.headerPad}>
                      <FormattedMessage
                        {...messages.CONF_DNAPLATES_SELECTED_WELL}
                      />
                      {row}
                      {col}
                    </h2>
                  </div>
                  <div>
                    <ValidationWarnings warnings={oligoNameWarning} />
                  </div>
                  {renderMixedData(specificationsData)}
                  <Grid container className={classes.conainerSpacing}>
                    <Grid item xs={6}>
                      <div>
                        <Grid container>
                          <Grid item xs={5}>
                            <Button
                              color="primary"
                              variant="contained"
                              size="large"
                              className={classes.AddModificationButton}
                              onClick={() => {
                                rulevalidateAndSave(idForward)
                              }}
                            >
                              <FormattedMessage
                                {...messages.CONF_DNAPLATES_UPDATE_WELL}
                              />
                            </Button>
                          </Grid>
                          <Grid item xs={7} className={classes.alignRight}>
                            <Button
                              color="primary"
                              variant="contained"
                              size="large"
                              className={classes.AddModificationButton}
                              onClick={clearWell}
                            >
                              <FormattedMessage
                                {...messages.CONF_DNAPLATES_CLEAR_WELL}
                              />
                            </Button>
                          </Grid>
                        </Grid>
                      </div>
                    </Grid>
                  </Grid>
                  {updateWellLoading && <CircleLoader />}
                </Paper>
              </div>
            </>
          )}
        </Formik>
      </Box>
      <DeleteAllDialog
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        type="SelectedWell"
        selectedItem={well}
        onDelete={deleteItems}
      />
    </div>
  )
}

export default OligoSequenceMixedWell
